import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';

const { BFF_URL, GBCORE_CLIENT_NAME, GBCORE_CLIENT_VERSION } = window.__ENV__;

// Action names
const ACTION_NAME_PREFIX = 'action/updateMemberEmailAddress';
export const REQUEST_ACTION_NAME = `${ACTION_NAME_PREFIX}/request`;
export const RESPONSE_ACTION_NAME = `${ACTION_NAME_PREFIX}/response`;
export const ERROR_ACTION_NAME = `${ACTION_NAME_PREFIX}/error`;

/**
 * Updates member email address for a member.
 * @param {object} logger
 * @returns {Promise<object>}
 */
export const UpdateMemberEmailAddress = (emailAddress) => {
    return async (dispatch, getState, { logger }) => {
        dispatch({ type: REQUEST_ACTION_NAME });

        const { jwt, sessionCorrelationId, language } = getState().Authentication;
        const transactionId = logger.generateGuid();

        logger.info(`${ACTION_NAME_PREFIX}: Updating member email address.`, { correlation: { transactionId } });

        const updateEmailMutation = await fetch(`${BFF_URL}/api/v2`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'gb-authorization': jwt,
                'mli-session-correlation-id': sessionCorrelationId,
                'mli-correlation-id': transactionId,
                'mli-channel': 'web',
                'gb-client-name': GBCORE_CLIENT_NAME,
                'gb-client-version': GBCORE_CLIENT_VERSION,
                'Accept-Language': language,
            },
            body: JSON.stringify({
                operationName: 'UpdateMemberEmailAddressMutation',
                variables: {
                    emailAddress,
                },
                query: `
                    mutation UpdateMemberEmailAddressMutation($emailAddress: String) {
                        updateMemberEmailAddressByGroup(emailAddress: $emailAddress)
                    }
                `,
            }),
        });

        const updateEmailMutationResponse = await updateEmailMutation.json();

        if (updateEmailMutationResponse.errors) {
            const { message, code } = updateEmailMutationResponse.errors[0];
            logger.error(
                `${ACTION_NAME_PREFIX}: Failure when updating member email address. Code: ${code} Reason: ${message}`,
                { correlation: { transactionId } }
            );
            return dispatch({
                type: ERROR_ACTION_NAME,
                code,
                message,
            });
        }
        return dispatch({ type: RESPONSE_ACTION_NAME, success: true, emailAddress });
    };
};

export const requestReducer = produce((state) => {
    state.MemberData.isSavingEmailAddress = true;
});

export const responseReducer = produce((state, action) => {
    state.MemberData.isSavingEmailAddress = false;
    state.MemberData.member.emailAddress = action.emailAddress;
});

/**
 * Fired off when the request encouters an error.
 * @param {object} state
 * @param {object} action
 */
export const errorReducer = produce((state, action) => {
    state.MemberData.isSavingEmailAddress = false;
    state.Errors.emailAddressUpdate.hasError = true;
    state.Errors.emailAddressUpdate.code = action.code;
    state.Errors.emailAddressUpdate.message = action.message;
});

registerReducer(REQUEST_ACTION_NAME, requestReducer);
registerReducer(RESPONSE_ACTION_NAME, responseReducer);
registerReducer(ERROR_ACTION_NAME, errorReducer);
